<template>
  <v-container class="fill-height text-center">
    <v-layout align-center justify-center row fill-height>
      <v-flex xs8>
        <h2>Su Token de Seguridad ha caducado, vuelva a iniciar sesión</h2>
        <h2>o revise su conexión e inténtelo nuevamente!!!</h2>
        <v-img :src="urlImage" height="125px" contain></v-img>

        <h2 class="reintentar">
          <a href="/login">Reintentar</a>
        </h2>
      </v-flex>
    </v-layout>
    <!--<v-row align="center">
      <v-col cols="8">
        <h2>Su Token de Seguridad ha caducado, vuelva a iniciar sesión</h2>
        <h2>o revise su conexión e inténtelo nuevamente!!!</h2>
        <v-img :src="urlImage" height="125px" contain></v-img>

        <h2 class="reintentar">
          <a href="/login">Reintentar</a>
        </h2>
      </v-col>
    </v-row>-->
  </v-container>
</template>

<script>
export default {
  data: () => ({
    urlImage: require("../assets/imgs/network_disconnected_1.png")
  }),
  mounted: function() {
    /*let local = window.localStorage.getItem("EPA_AUTH");
    if (local != null) {
      window.localStorage.removeItem("EPA_AUTH");
    }*/
  }
};
</script>

<style>
h2 {
  padding-bottom: 10px;
}

.reintentar {
  padding-top: 40px !important;
}

a {
  color: black;
}
</style>